import React from "react";
import { validateManySpace } from "../../helpers/Validation";
const TextAreaElement = (props) => {
  let errorBorder = "";
  const validateRegax = (e) => {
    if (!validateManySpace(e.target.value)) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        e.target.value,
        props.index,
        props.buildingIndex,
        props.floorIndex
      );
    }
  };
  return (
    <>
      <div className={props.mb4}>
        <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
          {props.labelText}
        </label>
        <textarea
          disabled={props.disabled}
          className={props.teaxtAreaClassName + errorBorder}
          id={props.teaxtAreaID}
          value={props.value}
          onChange={(e) => {
            const value = e.target.value;
            if (props.allowedPattern) {
              // Check if the value matches the allowed pattern
              if (value === "" || props.allowedPattern.test(value)) {
                return validateRegax(e);
              }
            } else {
              return validateRegax(e);
            }
          }}
          maxLength={props.maxLength || ""}
        />
        {props.pText && <p className={props.pClassName}>{props.pText}</p>}
      </div>
    </>
  );
};

export default TextAreaElement;
